import { render, staticRenderFns } from "./RowBlockPaymentInsuranceThroughInvoicing.vue?vue&type=template&id=8ed041d6&"
import script from "./RowBlockPaymentInsuranceThroughInvoicing.vue?vue&type=script&lang=js&"
export * from "./RowBlockPaymentInsuranceThroughInvoicing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports